import React from "react";

const CERTS = [
  {
    name: "NFRC Certified",
    org: "National Fenestration Rating Council",
    blurb:
      "Every ViewLux unit ships with the NFRC label — independently certified U-factor, Solar Heat Gain Coefficient, Visible Transmittance, and Air Leakage performance ratings.",
    logo: "/viewlux/certifications/nfrc.png",
    logoMaxH: 96,
    href: "https://www.nfrc.org/",
  },
  {
    name: "AAMA Gold Label",
    org: "Fenestration & Glazing Industry Alliance",
    blurb:
      "Our window and door systems carry the AAMA Gold Label — verified compliance with AAMA/WDMA/CSA 101/I.S.2/A440 for structural, water, air, and thermal performance.",
    logo: "/viewlux/certifications/aama.svg",
    logoMaxH: 96,
    href: "https://fgiaonline.org/product-certification/gold-label-certification/",
  },
];

export default function Certifications() {
  return (
    <section
      data-testid="certifications-section"
      id="certifications"
      className="relative bg-cream border-y border-[#c99658]/15"
    >
      <div className="container-vlx py-20 md:py-24">
        <div className="text-center max-w-2xl mx-auto">
          <span className="eyebrow">Certified Performance</span>
          <div className="mt-4 rule-gold mx-auto" />
          <h2 className="heading-lg mt-8 text-[28px] md:text-[40px] leading-[1.1] text-[#0f2420]">
            NFRC &amp; AAMA certified{" "}
            <em className="italic font-light text-[#7a5b2f]">
              aluminum windows &amp; doors.
            </em>
          </h2>
          <p className="mt-6 text-neutral-700 text-[14.5px] leading-[1.85] font-nunito">
            ViewLux windows and doors are independently rated and certified to
            the highest performance standards in North America. Every product
            in our line carries verifiable third-party documentation.
          </p>
        </div>

        <ul className="mt-14 md:mt-20 grid sm:grid-cols-2 gap-px bg-[#c99658]/25 max-w-5xl mx-auto">
          {CERTS.map((c, i) => (
            <li
              key={c.name}
              data-testid={`cert-card-${i}`}
              className="group bg-cream p-8 md:p-12 flex flex-col items-center text-center transition-colors duration-500 hover:bg-white"
            >
              <a
                href={c.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Learn about ${c.name} — ${c.org}`}
                className="flex flex-col items-center"
                data-testid={`cert-link-${i}`}
              >
                <div className="h-24 flex items-center justify-center">
                  <img
                    src={c.logo}
                    alt={`${c.name} logo`}
                    loading="lazy"
                    decoding="async"
                    style={{ maxHeight: c.logoMaxH }}
                    className="w-auto object-contain transition-transform duration-500 group-hover:scale-[1.05]"
                  />
                </div>
                <div className="mt-6 text-[10.5px] tracking-[0.4em] uppercase font-raleway text-[#7a5b2f]">
                  {c.org}
                </div>
                <h3 className="heading-lg mt-3 text-[22px] md:text-[26px] text-[#0f2420] leading-[1.15]">
                  {c.name}
                </h3>
                <p className="mt-4 text-neutral-700 text-[14px] leading-[1.85] font-nunito max-w-sm">
                  {c.blurb}
                </p>
                <span className="mt-6 inline-flex items-center gap-1 text-[10px] tracking-[0.4em] uppercase font-raleway text-[#7a5b2f] group-hover:text-[#c99658] transition-colors">
                  Verify the Standard &rarr;
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
